import { setAssetToCast, setPinNeeded } from 'store/cast/actions';
import { SET_ASSET_TO_CAST, SET_PIN_NEEDED } from 'store/cast/constants';
import { CastReduxState } from 'store/cast/reducer.types';

const initialState: CastReduxState = {
    pinNeeded: false,
    itemToCast: {
        videoItem: undefined,
        playbackType: undefined,
    },
};

const handlers = {
    [SET_PIN_NEEDED](
        state: CastReduxState,
        { payload: { pinNeeded } }: ReturnType<typeof setPinNeeded>,
    ): CastReduxState {
        return {
            ...state,
            pinNeeded,
        };
    },
    [SET_ASSET_TO_CAST](
        state: CastReduxState,
        {
            payload: { videoItem, playbackType },
        }: ReturnType<typeof setAssetToCast>,
    ): CastReduxState {
        return {
            ...state,
            itemToCast: {
                videoItem,
                playbackType,
            },
        };
    },
};

export default { initialState, handlers };
